<ng-container #prefix />
<div class="label" min-width-0>
  <ng-content />
</div>
<ng-container #suffix />
